import { ButtonBase } from '@material-ui/core'
import FilterCenterFocusIcon from '@material-ui/icons/FilterCenterFocus'
import { styled } from '@material-ui/styles'
import { LatLngBounds } from 'leaflet'
import { FC, memo } from 'react'
import { useMap } from 'react-leaflet'

import CustomControl from '../custom-control'

type CentralizationControlProps = {
  bounds?: LatLngBounds
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright'
}

const Button = styled(ButtonBase)(() => ({
  backgroundColor: '#fff',
  padding: '0.3rem 0.55rem',
  '& > svg': {
    width: 19,
  },
}))

const CentralizationControl: FC<CentralizationControlProps> = ({
  bounds,
  position = 'topleft',
}) => {
  const map = useMap()

  const handleButton = () => {
    bounds && map.fitBounds(bounds)
  }

  return (
    <CustomControl
      data-testid='centralization-control'
      style={{
        overflow: 'hidden',
      }}
      position={position}
    >
      <Button aria-label='centralization' onClick={handleButton}>
        <FilterCenterFocusIcon />
      </Button>
    </CustomControl>
  )
}

export default memo(CentralizationControl)
